@if (mainBanner) {
@if (moneyBackVisible) {
  @if (added) {
    <div class="tw-px-4 tw-py-4">
      <ng-container *ngTemplateOutlet="mainBannerCard"></ng-container>
    </div>
  } @else {
    <div class="tw-px-5 tw-pb-8">
      <div class="tw-flex tw-mb-3 tw-items-center tw-justify-center tw-font-body tw-text-[36px] tw-leading-10 tw-text-gray-500">+</div>
      <div class="tw-rounded-xl tw-border tw-border-dashed tw-border-orange-200 tw-bg-orange-100 tw-p-4">
        <ng-container *ngTemplateOutlet="mainBannerCard"></ng-container>
      </div>
    </div>
  }
} @else if (added) {
  <div class="tw-px-4 tw-py-4">
    <ng-container *ngTemplateOutlet="mainBannerCard"></ng-container>
  </div>
} @else {
  <div class="tw-border-b tw-border-dashed tw-border-orange-200 tw-bg-orange-100 tw-px-4 tw-py-4">
    <ng-container *ngTemplateOutlet="mainBannerCard"></ng-container>
  </div>
}

<ng-template #mainBannerCard>
  <section
    class="tw-flex tw-min-h-14 tw-w-full tw-items-center tw-justify-between tw-gap-3 tw-rounded-[9px] tw-bg-gray-75 tw-p-3 tw-shadow-z1"
    [class.tw-cursor-pointer]="!added"
    [attr.role]="added ? null : 'button'"
    [attr.tabindex]="added ? null : 0"
    data-node-id="67283:19571"
    (click)="!added && handleAction($event)"
    (keydown.enter)="!added && handleAction($event)"
    (keydown.space)="!added && handleAction($event)"
  >
    <div class="tw-flex tw-min-w-0 tw-flex-1 tw-items-center tw-gap-3">
      <div class="tw-relative tw-flex tw-h-[30px] tw-w-[30px] tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-100">
        <img class="tw-h-[10px] tw-w-[18px]" src="/assets/images/3000_crown.svg" alt="" />
        @if (added) {
          <span class="tw-absolute tw-right-0 tw-top-0 tw-flex tw-h-[10px] tw-w-[10px] tw-items-center tw-justify-center tw-rounded-full tw-bg-green-400 tw-font-body tw-text-[8px] tw-font-bold tw-text-white">✓</span>
        }
      </div>
      <div class="tw-min-w-0 tw-py-[3px]">
        <p class="tw-font-lexend tw-text-[14px] tw-font-bold tw-leading-[16.8px] tw-text-gray-800" [class.tw-whitespace-nowrap]="!userService.isDravidianLanguage">
          @if (added) {
            <span i18n="@@premiumServiceAdded">Priority Care added</span>
          } @else {
            <span i18n="@@premiumService">Priority Care</span>
          }
          <span class="tw-whitespace-nowrap">&nbsp;@ ₹800</span>
        </p>
        <p class="tw-font-body tw-text-[10px] tw-leading-[15px] tw-text-gray-500" i18n="@@premiumServiceMainBannerBenefitsSummary">Doctor video call + 4 benefits</p>
      </div>
    </div>
    @if (showAction) {
      <span
        class="tw-flex tw-shrink-0 tw-items-center tw-justify-center tw-font-body tw-leading-[18px] tw-text-[12px]"
        [class.tw-h-6]="!added"
        [class.tw-w-14]="!added"
        [class.tw-rounded-[6px]]="!added"
        [class.tw-bg-teal-600]="!added"
        [class.tw-px-3]="!added"
        [class.tw-font-lexend]="!added"
        [class.tw-font-semibold]="!added"
        [class.tw-text-white]="!added"
        [class.tw-text-gray-500]="added"
        [class.tw-underline]="added"
        [attr.aria-label]="added ? 'Remove Priority Care' : 'Add Priority Care'"
        [attr.role]="added ? 'button' : null"
        [attr.tabindex]="added ? 0 : null"
        (click)="handleAction($event)"
        (keydown.enter)="handleAction($event)"
        (keydown.space)="handleAction($event)"
      >
        @if (added) {
          <span i18n="@@removePriorityCare">Remove</span>
        } @else {
          <span class="tw-text-nowrap" i18n="@@add">Add</span>
        }
      </span>
    }
  </section>
</ng-template>
} @else {
<section
  class="tw-mx-4 tw-my-3 tw-flex tw-min-h-[56px] tw-items-center tw-justify-between tw-rounded-xl tw-bg-orange-100 tw-px-3 tw-py-2 tw-shadow-z1"
  [class.tw-cursor-pointer]="!added"
  [attr.role]="added ? null : 'button'"
  [attr.tabindex]="added ? null : 0"
  [attr.data-node-id]="compact ? '66623:80874' : '66623:77607'"
  (click)="!added && handleAction($event)"
  (keydown.enter)="!added && handleAction($event)"
  (keydown.space)="!added && handleAction($event)"
>
  <div class="tw-flex tw-min-w-0 tw-items-center tw-gap-2">
    <div class="tw-flex tw-h-[30px] tw-w-[30px] tw-shrink-0 tw-items-center tw-justify-center tw-rounded-full tw-bg-gray-100">
      <img class="tw-h-4 tw-w-4" src="/assets/images/3000_crown.svg" alt="" />
    </div>
    <div class="tw-min-w-0">
      <p class="tw-font-lexend tw-text-[14px] tw-font-bold tw-leading-[17px] tw-text-gray-800">
        @if (added) {
          <span><span i18n="@@premiumServiceAdded">Priority Care added</span><span class="tw-whitespace-nowrap">&nbsp;@ ₹800</span></span>
        } @else {
          <span><span i18n="@@addPremiumServiceToRegimen">Add Priority Care</span><span class="tw-whitespace-nowrap">&nbsp;@ ₹800</span></span>
        }
      </p>
      <p class="tw-font-body tw-text-[10px] tw-leading-[15px] tw-text-gray-500">
        @if (added) {
          <span i18n="@@premiumServiceBenefitsSummary">Includes doctor video call + 4 benefits</span>
        } @else {
          <span i18n="@@priorityCareBenefitsSummary">Video call with doctor + 4 benefits</span>
        }
      </p>
    </div>
  </div>

  <span
    type="button"
    class="tw-ml-2 tw-shrink-0 tw-rounded-lg tw-border-[1.1px] tw-border-solid tw-border-teal-600 tw-bg-gray-75 tw-px-4 tw-py-1 tw-font-lexend tw-text-[14px] tw-font-semibold tw-leading-[21px] tw-text-teal-600"
    [attr.aria-label]="added ? 'Remove Priority Care' : 'Add Priority Care'"
    (click)="handleAction($event)"
  >
    @if (added) {
      <span i18n="@@remove"> Remove </span>
    } @else {
      <span i18n="@@add">Add</span>
    }
  </span>
</section>
}
